import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useCreateOutletMutation } from "../slices/OutletSlice";
import FieldWarning from "../components/FieldWarning";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const CreateOutletScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  // const [outletId, setOutletId] = useState("");
  const [outletGroup, setOutletGroup] = useState("");
  // const [companyId, setCompanyId] = useState();
  const [seperateGst, setSeperateGst] = useState(true);
  const [outletCategory, setOutletCategory] = useState("");
  const [outletName, setOutletName] = useState("");
  const [outletAddress, setOutletAddress] = useState("");
  const [outletPincode, setOutletPincode] = useState("");
  const [outletState, setOutletState] = useState("Select State");
  const [outletContact, setOutletContact] = useState(
    userInfo?.mobileNumber.toString()
  );
  const [addedBy, setAddedBy] = useState("");
  const [operationStatus, setOperationStatus] = useState(true);
  const [openingHour, setOpeningHour] = useState("");
  const [closingHour, setClosingHour] = useState("");
  const [openedDays, setOpenedDays] = useState([]);

  const [outletIdPresent, setOutletIdPresent] = useState(false);
  const [outletGroupPresent, setOutletGroupPresent] = useState(false);
  const [companyIdPresent, setCompanyIdPresent] = useState(false);
  const [seperateGstPresent, setSeperateGstPresent] = useState(false);
  const [outletNamePresent, setOutletNamePresent] = useState(false);
  // const [outletCategoryPresent, setOutletCategoryPresent] = useState(false);
  const [outletStatePresent, setOutletStatePresent] = useState(false);
  const [currentlyOpenPresent, setCurrentlyOpenPresent] = useState(false);
  const [outletContactPresent, setOutletContactPresent] = useState(false);
  const [outletAddressPresent, setOutletAddressPresent] = useState(false);
  const [outletPincodePresent, setOutletPincodePresent] = useState(false);
  const [addedByPresent, setAddedByPresent] = useState(false);

  const sepGst = ["Yes", "No"];
  const openStatus = ["Yes", "No"];
  const outCat = [
    "Select Category",
    "Restaurant",
    "Bakery",
    "Food Truck",
    "Theatre",
    "Bars",
    "Hotel",
    "Company",
    "Transport",
    "Train",
  ];

  const availableStateNames = [
    "Select State",
    "Andhra Pradesh",
    "Karnataka",
    "Kerala",
    "Maharashtra",
    "Tamil Nadu",
    "Telangana",
  ];
  const daysOfWeek = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const [registerOutlet, { isLoading }] = useCreateOutletMutation();

  const handleCheckboxChange = (day) => {
    setOpenedDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };
  useEffect(() => {
    // if (outletId?.length === 3) {
    //   setOutletIdPresent(false);
    // }

    // if (companyId?.length === 4) {
    //   setCompanyIdPresent(false);
    // }

    if (outletName?.trim().length > 0) {
      setOutletNamePresent(false);
    }

    if (outletState !== "Select State") {
      setOutletStatePresent(false);
    }

    if (outletAddress?.length > 10) {
      setOutletAddressPresent(false);
    }

    if (outletPincode?.length === 6) {
      setOutletPincodePresent(false);
    }

    if (outletContact?.length === 10) {
      setOutletContactPresent(false);
    }

    if (addedBy?.trim().length > 0) {
      setAddedByPresent(false);
    }

    // if (operationStatus) {
    //   setCurrentlyOpenPresent(false);
    // }

    // if (openedDays.length > 0) {
    //   setSeperateGstPresent(false);
    // }
  }, [
    // outletId,
    // companyId,
    outletName,
    outletState,
    outletAddress,
    seperateGst,
    outletPincode,
    outletContact,
    operationStatus,
    openedDays,
    addedBy,
  ]);

  const verifyInputFields = () => {
    let fieldValidationSuccess = true;

    // if (outletId?.length !== 3) {
    //   setOutletIdPresent(true);
    //   fieldValidationSuccess = false;
    // }

    // if (companyId?.length !== 4) {
    //   setCompanyIdPresent(true);
    //   fieldValidationSuccess = false;
    // }

    if (outletName?.trim().length < 1) {
      setOutletNamePresent(true);
      fieldValidationSuccess = false;
    }

    if (outletState === "Select State") {
      setOutletStatePresent(true);
      fieldValidationSuccess = false;
    }

    if (outletAddress?.length < 10) {
      setOutletAddressPresent(true);
      fieldValidationSuccess = false;
    }

    if (outletPincode?.length !== 6) {
      setOutletPincodePresent(true);
      fieldValidationSuccess = false;
    }

    if (outletContact?.length !== 10) {
      setOutletContactPresent(true);
      fieldValidationSuccess = false;
    }

    if (addedBy.trim().length === 0) {
      setAddedByPresent(true);
      fieldValidationSuccess = false;
    }

    if (!fieldValidationSuccess) {
      toast.error(
        "Some fields have invalid inputs. Please provide valid details."
      );
    }
    return fieldValidationSuccess;
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (verifyInputFields())
      try {
        const res = await registerOutlet({
          outletId: userInfo.outletId,
          outletGroup: outletGroup,
          companyId: userInfo.companyId?._id,
          separateGst: seperateGst,
          outletCategory: outletCategory,
          outletName: outletName,
          outletAddress: outletAddress,
          outletPincode: outletPincode,
          outletState: outletState,
          outletContact: Number(outletContact),
          addedBy: addedBy,
          currentlyOpen: operationStatus,
          openingHour: openingHour,
          closingHour: closingHour,
          openedDays: openedDays,
          operationStatus: operationStatus,
          token: userInfo.token,
        }).unwrap();
        if (res) {
          toast.success("Outlet Registered Successfully");
          // setOutletId("");
          setOutletGroup("");
          // setCompanyId("");
          setSeperateGst(true);
          setOutletCategory("");
          setOutletName("");
          setOutletAddress("");
          setOutletPincode("");
          setOutletState("Select State");
          setOutletContact("");
          setAddedBy("");
          setOperationStatus(true);
          setOpeningHour("");
          setClosingHour("");
          setOpenedDays([]);
        }
      } catch (e) {
        toast.error(e?.data?.error);
      }
  };

  return (
    <div>
      <h5>Create Outlet</h5>
      <Row
        style={{
          display: "flex",
          marginTop: "3rem",
          margnLeft: "15rem",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Form>
          {/* <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>Outlet Id </strong>{" "}
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                // pattern="[0-9]"
                value={outletId}
                onChange={(e) => {
                  const val = e.target.value.replace(/[^0-9]/g, "");
                  setOutletId(val);
                }}
                placeholder="Enter Outlet Id"
              />
              {outletIdPresent ? (
                <FieldWarning text="Outlet Id should be 3 chars long" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group> */}

          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>Outlet Name</strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                value={outletName}
                onChange={(e) => setOutletName(e.target.value)}
                placeholder="Enter outlet name"
              />
              {outletNamePresent ? (
                <FieldWarning text="Please enter outlet name" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong> Outlet Address</strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                value={outletAddress}
                onChange={(e) => setOutletAddress(e.target.value)}
                placeholder="Enter address"
              />
              {outletAddressPresent ? (
                <FieldWarning text="Address should be atleast 10 chars long" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>Outlet Pincode</strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                // pattern="[0-9]"
                value={outletPincode}
                onChange={(e) => {
                  const val = e.target.value.replace(/[^0-9]/g, "");
                  setOutletPincode(val);
                }}
                placeholder="Enter Pincode"
              />
              {outletPincodePresent ? (
                <FieldWarning text="Pincode should be 6 chars long" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>State</strong>
              <label style={{ color: "red" }}>*</label> :
            </Form.Label>
            <Col sm="4">
              <Form.Select
                value={outletState}
                onChange={(e) => setOutletState(e.target.value)}
                placeholder="Select State"
              >
                {availableStateNames?.map((e) => (
                  <option key={e} value={e}>
                    {e}
                  </option>
                ))}
              </Form.Select>
              {outletStatePresent ? (
                <FieldWarning text="Please Select State" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>Outlet Contact</strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                // pattern="[0-9]"
                value={outletContact}
                onChange={(e) => {
                  const val = e.currentTarget.value.replace(/[^0-9]/g, "");
                  setOutletContact(val);
                }}
              />
              {outletContactPresent ? (
                <FieldWarning text="Contact number should be 10 digits" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>
                {" "}
                In Operation Now ?<label style={{ color: "red" }}>*</label>
              </strong>
            </Form.Label>
            <Col sm="6">
              <div className="horizontal-radio-group">
                {openStatus?.map((option) => (
                  <Form.Check
                    key={option}
                    type="radio"
                    label={option}
                    name="currentlyOpen"
                    id={`currentlyOpen-${option}`}
                    value={option}
                    checked={operationStatus === (option === "Yes")}
                    onChange={(e) =>
                      setOperationStatus(e.target.value === "Yes")
                    }
                  />
                ))}
              </div>
              {/* {currentlyOpenPresent ? (
                <FieldWarning text="Please mention currently open or not" />
              ) : (
                ""
              )} */}
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>Opening Time</strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                value={openingHour}
                onChange={(e) => setOpeningHour(e.target.value)}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>Closing Time</strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                // pattern="[0-9]"
                value={closingHour}
                onChange={(e) => setClosingHour(e.target.value)}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>Opened Days</strong>
            </Form.Label>
            <Col sm={9}>
              <Row>
                {daysOfWeek.map((day) => (
                  <Col key={day} xs={6} sm={4} className="mb-2">
                    <Form.Check
                      type="checkbox"
                      id={`day-${day}`}
                      label={day}
                      checked={openedDays.includes(day)}
                      onChange={() => handleCheckboxChange(day)}
                    />
                  </Col>
                ))}
              </Row>
            </Col>
          </Form.Group>

          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>Outlet Category</strong>
            </Form.Label>
            <Col>
              <Form.Select
                value={outletCategory}
                onChange={(e) => setOutletCategory(e.target.value)}
                placeholder="Enter outlet category"
              >
                {outCat?.map((e) => (
                  <option key={e} value={e}>
                    {e}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>Outlet Group</strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                value={outletGroup}
                onChange={(e) => setOutletGroup(e.target.value)}
                placeholder="Enter Outlet Group"
              />
            </Col>
          </Form.Group>
          {/* <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>Company Id </strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                // pattern="[0-9]"
                value={companyId}
                onChange={(e) => {
                  const val = e.target.value.replace(/[^0-9]/g, "");
                  setCompanyId(val);
                }}
                placeholder="Enter Company Id"
              />
              {companyIdPresent ? (
                <FieldWarning text="Company Id should be 4 chars long" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group> */}
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>
                {" "}
                Seperate GST ?<label style={{ color: "red" }}>*</label>
              </strong>
            </Form.Label>
            <Col sm="6">
              <div className="horizontal-radio-group">
                {sepGst?.map((option) => (
                  <Form.Check
                    key={option}
                    type="radio"
                    label={option}
                    name="platRadio"
                    id={`platRadio-${option}`}
                    value={option}
                    checked={seperateGst === (option === "Yes")}
                    onChange={(e) => setSeperateGst(e.target.value === "Yes")}
                  />
                ))}
              </div>
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>Added By</strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                // pattern="[A-Za-z]+"
                value={addedBy}
                onChange={(e) => {
                  const val = e.target.value.replace(/[^a-zA-Z]/g, "");
                  setAddedBy(val);
                }}
              />
              {addedByPresent && <FieldWarning text="This field is required" />}
            </Col>
          </Form.Group>
          <Row className="justify-content-center">
            <Col xs="auto">
              <Button onClick={submitHandler}>Submit</Button>
            </Col>
          </Row>
        </Form>
      </Row>
    </div>
  );
};

export default CreateOutletScreen;
